import { render, staticRenderFns } from "./ListResponsavelView.vue?vue&type=template&id=30f03732&scoped=true&"
import script from "./ListResponsavelView.vue?vue&type=script&lang=ts&"
export * from "./ListResponsavelView.vue?vue&type=script&lang=ts&"
import style0 from "./ListResponsavelView.vue?vue&type=style&index=0&id=30f03732&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f03732",
  null
  
)

export default component.exports